import React from 'react';

import {
  AppstoreOutlined,
  EditOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  RobotOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
} from '@ant-design/icons';

export const iconsMapping = {
  assistant: <RobotOutlined />,
  integrations: <AppstoreOutlined />,
  invoices: <DollarOutlined />,
  orders: <ShoppingCartOutlined />,
  reports: <EditOutlined />,
  'report-review': <FileDoneOutlined />,
  research: <FileSearchOutlined />,
};
